/**
 * @generated SignedSource<<69a7e418cbc0cb8ba1fc4c180f8fec09>>
 * @relayHash 22483ba9c1753bcc599212d651ddcc4f
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

// @relayRequestID 22483ba9c1753bcc599212d651ddcc4f

var node = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Data",
    "kind": "LinkedField",
    "name": "data",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Region",
        "kind": "LinkedField",
        "name": "regions",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "SelectRegionQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "SelectRegionQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "id": "22483ba9c1753bcc599212d651ddcc4f",
    "metadata": {},
    "name": "SelectRegionQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

node.hash = "999e27d10fd8b87363c6b8edfedbc3f6";

export default node;
